import React from 'react';
const testimonials = [{
  initials: 'MR',
  name: 'Matías R.',
  location: '📍 Buenos Aires | Emprendedor Digital',
  quote: '"Compré un domingo a la noche. El lunes arranqué con el Protocolo de Reset y en 3 días ya sentía la diferencia. Por primera vez en años terminé una semana sin ese nudo en el estómago. El sistema funciona de verdad."'
}, {
  initials: 'FS',
  name: 'Federico S.',
  location: '📍 Córdoba | Freelancer & Creador de Contenido',
  quote: '"Llevaba 2 años con el mismo proyecto parado. Con el Sistema de 3 Bloques lo terminé en una semana. No porque de repente tuve más ganas, sino porque el sistema hace que ejecutar sea el camino de menor resistencia."'
}, {
  initials: 'VA',
  name: 'Valentina A.',
  location: '📍 Rosario | Diseñadora Independiente',
  quote: '"El Modo Antialgoritmo del Bono 1 me devolvió las mañanas. Configuré el celular en 20 minutos y al día siguiente arranqué a trabajar sin tocarlo. Produje más en 2 horas que antes en todo el día. Brutal."'
}, {
  initials: 'JP',
  name: 'Julián P.',
  location: '📍 Mendoza | Desarrollador Web Independiente',
  quote: '"El Protocolo de Apagado Mental del Bono 3 eliminó la ansiedad nocturna. Antes tardaba 2 horas en dormirme pensando en todo lo que no había hecho. Ahora en 7 minutos cierro el día y duermo. Primera vez en años."'
}, {
  initials: 'LC',
  name: 'Lucía C.',
  location: '📍 Tucumán | Estudiante Universitaria + Emprendedora',
  quote: '"Nunca creí que el problema era mi dopamina y no mi fuerza de voluntad. Después del Tomo 2 entendí todo. Dejé de pelear contra mí misma y empecé a usar el sistema. En 2 semanas terminé 3 proyectos parados."'
}, {
  initials: 'PR',
  name: 'Pablo R.',
  location: '📍 Santa Fe | Consultor de Marketing',
  quote: '"El Tablero de Control a 90 días me cambió la cabeza. Por primera vez veo mi progreso en tiempo real. No es motivación lo que necesitaba, era datos. Ahora ejecuto con claridad y sin excusas. Esto es diferente."'
}, {
  initials: 'AG',
  name: 'Agustina G.',
  location: '📍 Salta | Fotógrafa & Creadora de Contenido',
  quote: '"El Tomo 5 (Protocolo S.O.S.) me salvó el mes más difícil del año. Tuve una semana de recaída total. Con el plan de rescate en 3 pasos volví al sistema sin drama ni culpa. No lo hubiera logrado sin eso."'
}];
export function Testimonials() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#111111',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-295">
      <div className="mx-auto max-w-4xl" data-id="element-296">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-2" data-id="element-297">
          Lo que dicen los que ya lo usan:
        </h2>
        <p className="text-center text-sm text-gray-400 m-0 mb-8" data-id="element-298">
          +1.200 ejecutores ya recuperaron el control de su atención con este
          sistema.
        </p>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-299">
          {testimonials.map((t, i) => <div key={i} className="rounded-xl p-5 shadow-sm border border-yellow-400/10 flex flex-col gap-3" style={{
          backgroundColor: 'rgba(255,255,255,0.03)'
        }} data-id="element-300">
              <div className="flex items-center gap-3" data-id="element-301">
                <div className="w-10 h-10 rounded-full bg-yellow-400 text-gray-900 flex items-center justify-center font-bold text-sm shrink-0" data-id="element-302">
                  {t.initials}
                </div>
                <div data-id="element-303">
                  <p className="font-bold text-white m-0 text-sm" data-id="element-304">
                    {t.name}
                  </p>
                  <p className="text-gray-500 m-0 text-xs" data-id="element-305">{t.location}</p>
                </div>
              </div>
              <p className="text-gray-300 m-0 text-sm italic leading-relaxed" data-id="element-306">
                {t.quote}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}